<template>
	<div>
		<div>
			
			<font style="color: red;" v-if="tb.ismust">*</font>
			<font style="color: red;" v-else="tb.ismust">&nbsp </font>
			{{tb.name}}
			</div>
		<van-uploader :max-count="tb.maxnum" v-model="fileList" :preview-full-image='false' multiple @click-preview='hell' :after-read="afterRead" />
		<br>
		<br>

	</div>
</template>

<script>
	import Vue from 'vue';
	import {
		Uploader
	} from 'vant';
	Vue.use(Uploader);
	export default {
		props: ["tb"],
		data() {
			return {
				msg :'33',
				fileList: [
				],
			}
		},

		computed:{
			pic(){
				let arr = [];
				for(let i in this.fileList){
					
					if(this.fileList[i].file){
						let obj = {}						
					obj["name"] = this.fileList[i].file.name.split('.')[0];
					obj["data"] = this.fileList[i].content; 
						arr.push(obj)	
					}else{
						let obj = {}
					obj["name"] = this.fileList[i].name;
					obj["data"] = this.fileList[i].content; 
						arr.push(obj)
					}					

				}
				if(arr.length!=0){
					return arr;
				}else{
					return '';
				}
				
			}
		},
		watch:{
			fileList(n,o){
				this.tb.val = this.pic
				
			}
		},
		mounted(){
			// console.log(this.tb);
			if(this.tb.val){
			let filelist =	this.tb.val.map(item=>{
				
					let obj = {};
					obj.name = item.name;
					obj.content = item.data;
					return obj;
				})

				this.fileList = filelist;
			}
			
		},
		methods: {
			afterRead(file){
					
							
 
			},
			hell(e) {
				e.content =	e.content.replace(/\s/g,'');
				let url = e.content;
				var gallery = weui.gallery(url, {
					className: 'custom-name',
					onDelete: () => {
						weui.confirm('确定删除该图片？',
							() => {
								let arr = this.fileList.filter((item) => {
									if (item === e) {
										return false;
									} else {
										return true;
									}
								});
								this.fileList = arr;
								gallery.hide();
							
							}
						);
					}
				});

			},
		}
	}
</script>

<style>
</style>



// WEBPACK FOOTER //
// src/fields/Uploader.vue